class ObjCommon {
  id: string = "";

  constructor(id?: string) {
    this.id = typeof id !== "undefined" ? id : "";
  }

  obSet(ob: Partial<ObjCommon>) {
    for (const key in ob) {
      if (Object.prototype.hasOwnProperty.call(ob, key)) {
        if (Object.prototype.hasOwnProperty.call(this, key)) {
          (this as any)[key] = ob[key as keyof ObjCommon];
        }
      }
    }
  }
}

export default ObjCommon;
